import VerifyForm from './verify-form'
import React, { useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useRealmApp } from '../../RealmApp'
import { IoMdClose } from 'react-icons/io';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { Button, Alert, Spinner } from 'react-bootstrap'
import { BiAnalyse } from 'react-icons/bi';
import { useSupabaseApp } from "../../SupabaseApp";

// This page is where a user confirms their account

/**
 * VerifyPage Component
 * 
 * Handles user account verification/activation flow.
 * Receives verification tokens from email link and confirms the account
 * with Supabase. Displays loading, success, and error states accordingly.
 * 
 * This page is accessed via email verification links that include token and tokenId
 * as URL query parameters.
 * 
 * @returns {JSX.Element} Verification form with activation flow
 */

function VerifyPage() {

    // Get confirmation method from Supabase context
    const { confirm } = useSupabaseApp();

    // Get URL search parameters containing verification tokens
    const search = useLocation().search;

    // Get history object for navigation
    const history = useHistory();

    // Extract token from URL query parameters
    const queryParamToken = new URLSearchParams(search).get('token');

    // Extract tokenId from URL query parameters
    const queryParamTokenId = new URLSearchParams(search).get('tokenId');

    // State for storing alert messages
    const [response, setResponse] = useState('')

    /**
     * Handle account confirmation/activation
     * Submits verification tokens to Supabase to confirm the email
     * @param {string} token - Verification token from email link
     * @param {string} tokenId - Token ID from email link
     */
    async function handleConfirm(token, tokenId) {
        // Show loading alert while processing
        setResponse(
            <Alert className="error-message floating-alert" variant="light">
                <div>
                    <div style={{ textAlign: "right" }}><Button className="pitchdeckmessageclose"
                        onClick={(event) => {
                            event.preventDefault()
                            setResponse("")
                        }}>
                        <IoMdClose /></Button></div>
                    <div style={{ display: "flex", paddingTop: "10px" }}>
                        <div style={{ width: "90%" }}>
                            <p><span style={{ color: "#0f9d58" }}><BiAnalyse className="alert-icon" /> Loading</span></p>
                            <p style={{ marginLeft: "28px", fontSize: "14px" }}>Attempting to activate your account</p>
                            <p style={{ marginLeft: "28px", fontSize: "14px" }}>If your waiting time is too long, <a href="https://www.roiquant.com/contact" target="_blank" rel="noopener noreferrer">contact us</a>.</p>
                        </div>
                        <div style={{ width: "10%", textAlign: "right" }}>
                            <Spinner animation="border" variant="secondary" />
                        </div>
                    </div>
                </div>
            </Alert>
        );

        try {
            // Attempt to confirm user account with provided tokens
            await confirm(token, tokenId)
            // console.log('Successfully confirmed user')
            // Redirect to login page on successful confirmation
            history.push('/login')
        } catch (error) {
            // Handle confirmation errors and display appropriate messages>
            if (error.error) {
                setResponse(
                    <Alert className="error-message floating-alert" variant="light">
                        <div style={{ textAlign: "right" }}><Button className="pitchdeckmessageclose" onClick={(event) => {
                            event.preventDefault()
                            setResponse("")
                        }}><IoMdClose /></Button></div>
                        <div style={{ paddingTop: "10px" }}>
                            <p style={{ color: "red" }}><AiOutlineCloseCircle className="alert-icon" /> Error</p>
                            <p style={{ marginLeft: "28px" }}>{error.error}</p>
                        </div>
                    </Alert>
                );
            } else {
                setResponse(
                    <Alert className="error-message floating-alert" variant="light">
                        <div style={{ textAlign: "right" }}><Button className="pitchdeckmessageclose" onClick={(event) => {
                            event.preventDefault()
                            setResponse("")
                        }}><IoMdClose /></Button></div>
                        <div style={{ paddingTop: "10px" }}>
                            <p style={{ color: "red" }}><AiOutlineCloseCircle className="alert-icon" /> Error</p>
                            <p style={{ marginLeft: "28px" }}>{error}</p>
                        </div>
                    </Alert>
                );
            }
        }
    }

    return (
        <VerifyForm handleConfirm={handleConfirm} token={queryParamToken} tokenId={queryParamTokenId} response={response} />
    )
}

export default VerifyPage